import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Status, UpdateStatus } from './status.interface';
import { catchError, map, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: "root",
})
export class StatusService {
  private token!: string;
  private basePath = environment.interop.basePath;
  private getStatusDTUrl =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.cerereStatus
      .getCerereStatusesDT;
  private storeStatusURL =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.cerereStatus
      .storeCerereStatus;

  private deleteStoreStatus =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.cerereStatus
      .deleteCerereStatus;

  private getStatusActive =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.cerereStatus
      .getCerereStatusesActive;

  private getStatusPublic =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.cerereStatus
      .getCerereStatusesActivePublic;

  private updateStatusStore =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.cerereStatus
      .putCerereStatus;

  private updateOrderUrl =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.cerereStatus
      .updateOrder;

  private changeStatusActiveUrl =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.cerereStatus
      .changeStatusCerereStatusActive;
  private changeStatusPublicUrl =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.cerereStatus
      .changeStatusCerereStatusPublic;

  private clearCacheUrl =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.cerereStatus
      .clearCache;

  // private getSolicitareRankURL = this.basePath + environment.interop.autorizatiiComerciale.nomenclatoare.cerereStatus.rankList;
  private getSolicitareRankURL =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.rank.rankList;

  private httpOptions: any;

  constructor(private http: HttpClient) {}

  getStatusDT() {
    return this.http.get(this.getStatusDTUrl, this.httpOptions);
  }

  clearCache() {
    return this.http.get(this.clearCacheUrl, this.httpOptions);
  }

  storeStatus(data: Status) {
    return this.http.post(this.storeStatusURL, data, this.httpOptions);
  }
  getActiveStatus() {
    return this.http.get(this.getStatusActive, this.httpOptions);
  }

  getPublicStatus() {
    return this.http.get(this.getStatusPublic, this.httpOptions);
  }

  updateStatus(updateStatus: UpdateStatus) {
    return this.http.put(
      this.updateStatusStore,
      updateStatus,
      this.httpOptions
    );
  }

  deleteStatus(sectionId: number) {
    return this.http.delete(this.deleteStoreStatus + sectionId);
  }

  setToken(token: string) {
    this.token = token;
    this.httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
  }

  getCerereStatuses() {
    return this.http
      .get<{ errors: boolean; data: any[]; status_code: number }>(
        this.getStatusActive
      )
      .pipe(
        map((response) =>
          response.data.map((item) => ({
            id: item.id,
            name: item.name,
          }))
        ),
        catchError((error) => {
          console.error("Error in get request priorities:", error);
          return throwError(error);
        })
      );
  }

  updateOrder(id: number, data: any) {
    return this.http.put(this.updateOrderUrl + id, data, this.httpOptions);
  }

  changeStatuseActive(id: number) {
    return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
  }

  changeStatusePublic(id: number) {
    return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
  }

  getRanksList() {
    return this.http
      .get<{ errors: boolean; data: any; status_code: number }>(
        this.getSolicitareRankURL
      )
      .pipe(
        map((response) => {
          // Transform the object into an array of its values
          const statusesArray = Object.values(response.data);
          // Map over this array to extract id, name, and slug
          return statusesArray.map((item:any) => ({
            id: item.id,
            name: item.name,
            slug: item.slug,
          }));
        }),
        catchError((error) => {
          console.error("Error in get directii active:", error);
          return throwError(error);
        })
      );
  }
}
